/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { BOOKING_DATE } from 'modules/transactions/constants';
/**
 * Common date change patterns are defined here
 */
export const DATE_PATTERN = 'MM-dd-yyyy';
//
export const YEAR_MONTH_DAY_PATTERN = 'yyyy-MM-dd';
//
export const DATE_TIME_PATTERN = 'yyyy-MM-dd HH:mm:ss';
//
export const DATE_TIME_ZONE_PATTERN = 'yyyy-MM-dd HH:mm:ss OOOO';
//
export const TIME_PATTERN = 'hh:mm:ss a';
//
export const ISO_YEAR_MONTH_DAY_PATTERN = 'yyyyMMdd';
/**
 * Default stay date min date is defined here
 */
export const STAY_DATE_START_DATE = '2015/01/01';
/**
 * Default stay date max date is defined here
 */
export const STAY_DATE_END_DATE = '2025/12/31';
/**
 * Default booking date min date is defined here
 */
export const BOOKING_DATE_START_DATE = BOOKING_DATE;
